import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import entityActionFactory from './factories/entityActionFactory';
import * as ajax from './ajax';
import pickerConstants from '../constants/pickerConstants';
import store from '../reducers/storeRegistration';
import loginActions from './loginActionCreators';
import tokenErrorActions from './tokenErrorActionCreators';
const entityActions = entityActionFactory('picker', 'pickers');
const pickerActions = _objectSpread({}, entityActions);
const serverSaveSuccess = list => ({
  type: pickerConstants.SAVE_ALL_SUCCESS,
  data: list
});
const serverSave = () => ({
  type: pickerConstants.SERVER_SAVE
});
const serverSaveFailure = () => ({
  type: pickerConstants.SERVER_SAVE_ALL_FAILURE
});
const getNextHighest = (currentIndex, list) => {
  const currentItem = list[currentIndex];
  for (let i = currentIndex + 1; i < list.length; i += 1) {
    const nextItem = list[currentIndex];
    if (nextItem.sortOrder > currentItem.sortOrder) {
      return nextItem.sortOrder;
    }
  }
  return null;
};
const changeSortOrders = function changeSortOrders() {
  let list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let forceReorder = false;
  let lastSortOrder = 0;
  return list.map((current, index) => {
    if (!current.hasChange && !forceReorder) {
      return current;
    }
    const next = list[index + 1];
    const prev = list[index - 1];
    let sortOrder = current.sortOrder;
    const _ref = prev || {},
      prevSortOrder = _ref.sortOrder;
    const _ref2 = next || {},
      nextSortOrder = _ref2.sortOrder;
    if (forceReorder) {
      lastSortOrder += 100;
      return _objectSpread(_objectSpread({}, current), {}, {
        sortOrder: lastSortOrder
      });
    }
    if (prevSortOrder === undefined && nextSortOrder === undefined) {
      // The only item in the list, leave it alone
      return _objectSpread(_objectSpread({}, current), {}, {
        sortOrder
      });
    }
    if (prevSortOrder === undefined) {
      // Must be the first item
      sortOrder = getNextHighest(index, list) - 100;
    } else if (nextSortOrder === undefined) {
      // Must be last item
      sortOrder = prevSortOrder + 100;
    } else if (sortOrder < nextSortOrder && sortOrder > prevSortOrder) {
      // The current ordering is sufficent, do nothing
      return _objectSpread(_objectSpread({}, current), {}, {
        sortOrder
      });
    } else if (prevSortOrder > nextSortOrder) {
      // Look ahead, getting the next highest value (if there is any)
      const nextHighest = getNextHighest(index, list);
      if (nextHighest === null) {
        // If there isn't anything larger then we need to shuffle the whole list up
        forceReorder = true;
        lastSortOrder = prevSortOrder + 100;
        sortOrder = lastSortOrder;
      } else {
        sortOrder = prevSortOrder + Math.round((nextHighest - prevSortOrder) / 2);
      }
    } else {
      sortOrder = prevSortOrder + Math.round((nextSortOrder - prevSortOrder) / 2);
    }
    // Need to modify the array in-place as well to ensure
    // the next element gets the updated sort order for the "prevSortOrder"
    // variable.
    /* eslint-disable-next-line no-param-reassign */
    current.sortOrder = sortOrder;
    return _objectSpread(_objectSpread({}, current), {}, {
      sortOrder
    });
  });
};
const serverSaveAll = (table, lang, disabled, rows) => async dispatch => {
  // Compute sort orders once before the request so we can safely retry with the same data
  const sortedData = changeSortOrders(rows);
  const makeRequest = async () => {
    dispatch(serverSave());
    return ajax.post('/pickers', {
      tableName: table,
      data: sortedData,
      disabled,
      lang
    });
  };
  let response;
  try {
    response = await makeRequest();
  } catch (e) {
    var _e$response;
    // If token expired (401), refresh and retry once with the same data
    if (((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
      try {
        await store.dispatch(loginActions.serverToken());
        response = await makeRequest();
      } catch (retryError) {
        return dispatch(tokenErrorActions.handleError(retryError, 'picker', serverSaveFailure));
      }
    } else {
      return dispatch(tokenErrorActions.handleError(e, 'picker', serverSaveFailure));
    }
  }
  return dispatch(serverSaveSuccess(response.data));
};
export default _objectSpread(_objectSpread({}, pickerActions), {}, {
  serverSaveAll
});